import React from 'react';
import Button from '../../Components/Button';

const Cirriculum = ({ toggleDownloadForm }) => {
  return (
    <section className="cirriculum-container">
      <div className="cirriculum-content">
        <div className="cirriculum-left">
          <p className="cirriculum-left-title">OUR CURRICULUM</p>
          <span className="cirriculum-left-description">
            This program is intended for students who already have knowledge of
            machine learning algorithms.
          </span>
        </div>

        <div className="cirriculum-right">
          <Button onClick={toggleDownloadForm} text="DOWNLOAD CURRICULUM" />
        </div>
      </div>
    </section>
  );
};

export default Cirriculum;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Curriculum.js